import Link from 'next/link';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import Heading from '../../../../atoms/Heading';
import BaseTemplate from '../../../../organisms/merchants/BaseTemplate';
import { MerchantDetail } from '../../../../interfaces/merchants';
import { CouponLinkCard } from '../../../../molecules/merchant/coupons/CouponLinkCard';
import css from './style.module.scss';
import { buildSiteUrl } from 'src/utils/request-url';

interface PageProps {
  // ゆくゆくはAPIの戻り値であるMerchantDetailをそのまま渡したくない
  merchant: MerchantDetail;
  coupons: { name: string; publicId: string }[];
  isCoubicApp: boolean;
}

const CouponIndexTemplate: FC<PageProps> = ({
  merchant,
  coupons,
  isCoubicApp,
}) => {
  const intl = useIntl();
  return (
    <BaseTemplate merchantDetail={merchant} isCoubicApp={isCoubicApp}>
      <div className={css.container}>
        <div className={css.mb_16px}>
          <Heading className={css['heading']}>
            <Link
              href={buildSiteUrl(`/coupons`, 'next')}
              prefetch={false}
              className={css.coupons_index_link}
            >
              {intl.formatMessage({
                id: 'couponIndexTemplate.headerTitle',
              })}
            </Link>
          </Heading>
        </div>
        {coupons.map((coupon) => {
          return (
            <CouponLinkCard
              key={coupon.publicId}
              coupon={{
                name: coupon.name,
                publicId: coupon.publicId,
              }}
            />
          );
        })}
      </div>
    </BaseTemplate>
  );
};

export default CouponIndexTemplate;
